
import { backendExceptionHandler } from "@/mixins";
import FormatterService from "@/service/FormatterService";

    export default {
        name: 'ShareNews',
        mixins: [backendExceptionHandler],
        props: {
             isin: {
                type: String,
                required: true,
            }
        },

        data () {
            return {
                news: [],
                relatedShares: {},
                isLoading: false,
                errorMessage: null,
            }
        },

        watch: {
            isin(newIsin) {
                this.queryNews(newIsin)
            }
        },

        created() {
            this.queryNews(this.isin)
            this.format = new FormatterService()
        },

        methods: {
            queryNews(isin) {
                this.isLoading = true

                this
                    .$axios
                    .get(`/api/news?isin=${isin}`)
                    .then(response => {
                        this.news = response.data
                    })
                    .catch(error => {
                        this.handleBackendException(error, this.$t('component.share.shareNews.errors.newsLoadFailed'))
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },

            openShare(isin) {
                if(isin != this.isin) {
                    this.$router.push({
                        name: 'Share',
                        params: {
                            isin: isin,
                            mic: 'XFRA'
                        }
                    })
                }
            },

            onImgError(e) {
                const element = e.target
                element.parentElement.classList.add("error-thumbnail")
                e.target.src = require('@/assets/money-peak-logos/money-peak-black-error-logo.png')
            },

            updateErrorMessage() {
                this.errorMessage = ""
            },
        }
    }
